import { Divider, Icon, Pill, ToolIcon, TooltipWrapper } from "@theorgchartdev/storybook";
import SyncChartPopover from "@/appComponents/Navigation/Header/SyncChartPopover/SyncChartPopover";
import AutoSavePopover from "@/appComponents/Navigation/Header/AutoSavePopover/AutoSavePopover";
import React, { Fragment, useRef } from "react";
import { useNavigationContext } from "@/providers/NavigationProvider";
import * as StateLib from "@/Utils/StateLib";
import { useChartDocumentContext } from "@/providers/ChartDocumentProvider";
import { QuickAccessMenu } from "@/appComponents/Navigation/Header/QuickAccessMenu/QuickAccessMenu";
import { RenameLayoutInput } from "@/appComponents/Navigation/Header/LeftHeaderControls/RenameLayoutInput";
import { RenameDocInput } from "@/appComponents/Navigation/Header/LeftHeaderControls/RenameDocInput";
import { Globals } from "@coreapp/CoreApp/Globals";
import { IsBackgroundFile } from "@coreapp/utils/IsBackgroundFile";
import { enumContainerType, enumDataSource } from "@coreapp/constants";
import { useWSMgrContext } from "@/providers/WsMgrProvider";
import { appstr } from "@coreapp/utils/appstr";
import { usePlanManagerContext } from "@/providers/PlanManagerProvider";
import {
  getSubmissionPillColors,
  getSubmissionsIcon,
  getSubmissionStatusDisplayName
} from "@/Utils/Plan/PlanSubmissionsStatuses";
import FieldTypePill from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/FieldsFormulasConfiguration/FieldTypePill";
import { HeaderNavIcon } from "@/appComponents/Navigation/MainNavigation/HeaderNavIcon";

export const GetCurrentChartIconProps = () => {
  const currentDoc = StateLib.GetDoc();
  const docMgr = currentDoc?.GetDocMgr();

  const wsMgr = StateLib.GetWSMgr();
  const currentFilename = wsMgr?.GetFileName(true);

  const isArchive =
    docMgr?.GetIWizDataInteractive()?.GetDataSource() === enumDataSource.pointintime;
  const isBackground = currentFilename ? IsBackgroundFile(currentFilename) : false;
  let iconProps = {
    name: "",
    title: ""
  };

  if (!currentDoc) return null;
  if (isBackground) {
    iconProps.name = "file-chart-pie";
  } else if (currentDoc.IsServerChart()) {
    if (currentDoc.IsPlanChart()) iconProps.name = "planning";
    else iconProps.name = "sitemap";
  } else if (isArchive) {
    iconProps.name = "clock-rotate-left";
  } else {
    iconProps.name = "diagram-project";
  }
  return iconProps;
};

export const LeftHeaderChartControls = ({
  showChartSelector,
  showSync,
  showAutoSave,
  hideChartControls,
  showFileName,
  showQuickAccess,
  showSubmissionStatus
}) => {
  const {
    chartExplorer: { openChartExplorer }
  } = useNavigationContext();

  const chartDocCtx = useChartDocumentContext();
  const { wsMgr: wsMgrCtx } = useWSMgrContext();
  const handleRef = useRef(null);

  const { planManager } = usePlanManagerContext();
  const planSubmission = planManager?.state?.GetPlanSubmission();
  const planSubmissionStatus = planSubmission?.status;

  if (hideChartControls) return;
  const doc = chartDocCtx.chartDocument.state;
  const isPositionChart = doc?.IsPositionDocument() ?? false;

  return (
    <Fragment>
      <HeaderNavIcon itemKey="chart" size="medium" />
      {showChartSelector && (
        <Fragment>
          <div className={"oc-shrink-0"}>
            <ToolIcon
              dataTestId={"header-explorer-btn"}
              name={"compass"}
              size={"medium"}
              aria-label={"Chart explorer"}
              onClick={() => openChartExplorer()}
              shape={"round"}
            />
          </div>
          <div className={"ocn-toolbar-horizontal-divider"}>
            <Divider vertical />
          </div>
        </Fragment>
      )}
      {showFileName && (
        <Fragment>
          {Globals._uiConfig.InBoxLayoutEditorMode() ? (
            <Fragment>
              <RenameLayoutInput />
              <TooltipWrapper
                tooltipProps={{
                  message:
                    wsMgrCtx?.state?.GetBLELayout()?.GetContainerType() ===
                    enumContainerType.standardmrb
                      ? isPositionChart
                        ? appstr("This box layout type is applied to position boxes.")
                        : appstr(
                            "This box layout type is applied to the grouped box that groups the employee records."
                          )
                      : appstr("This box layout type is applied to employee boxes.")
                }}
              >
                <FieldTypePill
                  type={
                    wsMgrCtx?.state?.GetBLELayout()?.GetContainerType() ===
                    enumContainerType.standardmrb
                      ? isPositionChart
                        ? "position"
                        : "group"
                      : "employee"
                  }
                  pillProps={{ size: "regular" }}
                />
              </TooltipWrapper>
            </Fragment>
          ) : (
            <RenameDocInput handleRef={handleRef} />
          )}
          {showSubmissionStatus && (
            <Pill
              label={getSubmissionStatusDisplayName(planSubmissionStatus)}
              color={getSubmissionPillColors(planSubmissionStatus)}
              leftContent={<Icon {...getSubmissionsIcon(planSubmissionStatus)} size={"small"} />}
            />
          )}
          {showQuickAccess && (
            <div style={{ paddingLeft: "2px" }}>
              <QuickAccessMenu doc={doc} handleRef={handleRef} />
            </div>
          )}
        </Fragment>
      )}
      {showSync && <SyncChartPopover doc={doc} />}
      {showAutoSave && <AutoSavePopover doc={doc} />}
    </Fragment>
  );
};
